import { forwardRef, type ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { type GenerateStatus } from '@/shared/features/ai-quiz-generation/types';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
interface BuildAiGeneratedResultContainerProps {
  resultDescription: ReactNode;
  selectedItemsCount: number;
  className?: string;
  onSelectAll: () => void;
  children: React.ReactNode;
  status: GenerateStatus;
}
export const BuildAiGeneratedResultContainer = forwardRef<HTMLDivElement, BuildAiGeneratedResultContainerProps>(({
  resultDescription,
  selectedItemsCount,
  className,
  onSelectAll,
  children,
  status
}, ref) => {
  const {
    t
  } = useTranslation(['build']);
  return <div ref={ref} className={cn('flex flex-col gap-lg tablet-sm:overflow-y-scroll bg-gray-50 py-lg tablet-sm:px-lg px-md w-full', className)}>
        <div className={'flex flex-col gap-md '}>
          <img src="/assets/ai_face.png" width={40} alt="airobot" />
          <div className={'flex justify-between'}>
            <div className={'flex flex-col gap-md'}>
              <span className={'text-heading-md-bold'}>
                {resultDescription}
              </span>
              <span className="text-body-md-semibold text-alternative">
                {t('build:build.ai.selectedQuizCountWithoutLimitCount', {
              selected: selectedItemsCount
            })}
              </span>
            </div>
            <div className={'flex h-full items-end'}>
              <Button size={'sm'} intent={'alternative'} rounded={'full'} variant={'outlined'} onClick={onSelectAll} disabled={status === 'regenerating'}>
                {selectedItemsCount === 0 ? t('ai.selectAll.button') : t('ai.select.deselectAll')}
              </Button>
            </div>
          </div>
        </div>
        <div className={'flex flex-col gap-sm'}>{children}</div>
      </div>;
});
BuildAiGeneratedResultContainer.displayName = 'BuildAiGeneratedResultContainer';